import { render } from "./App.vue?vue&type=template&id=73f070a5"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=73f070a5&lang=css"

import exportComponent from "D:\\web\\dmsm\\dmsm-pages\\cloud\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__